<template>
  <div class="noticias">
    <header-primary
      title="Notícias"
      subtitle="Notícias e dicas."
      :image="require('../assets/background/bg_line_newspaper.jpg')"></header-primary>
    <lazy-load-page v-if="state.main === state.load"></lazy-load-page>
    <error-content-page @handleButton="findNews" v-if="state.main === state.error"></error-content-page>
    <empty-content-page v-if="state.main === state.empty"></empty-content-page>
    <div v-if="state.main === state.content">
      <container-black-x class="pb-5 pt-5 md-elevation-5">
        <div class="container">
          <div class="container pb-1 pt-1 mb-5 md-elevation-4 bg-dark border-primary border">
            <h1 class="md-headline font-weight-bold text-white">Destaques</h1>
          </div>
          <div class="row justify-content-center align-items-end">
            <div :class="idx === 1 ? 'col-10 mt-4 col-lg-4 mb-4' : 'col-lg-3 col-8'" v-for="(d, idx) in newsDestak" :key="idx">
              <destak-card
                :image="d.imagemNome"
                :title="d.titulo"
                :subtitle="d.descricao"
                :date="d.data"
              ></destak-card>
            </div>
          </div>
        </div>
      </container-black-x>
      <div class="container">
        <h1 class="md-headline font-weight-bold ">Outras Notícias</h1>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 mb-4" v-for="(o, idx) in news" :key="idx">
            <h3 class="d-sm-inline-block d-md-none">{{o.titulo}}</h3>
            <destak-card
              :image="o.imagemNome"
              :title="o.titulo"
              :subtitle="o.descricao"
              :date="o.data"
            ></destak-card>
          </div>
        </div>
      </div>
    </div>
    <social-bar class-color="bg-dark" :mod="true" :telegram="sharedState.cityInfo.telegram.id"></social-bar>
  </div>
</template>

<script>
  import HeaderPrimary from "../components/HeaderPrimary";
  import DestakCard from "../components/DestakCard";
  import ContainerBlackX from "../components/ContainerBlackX";
  import LazyLoadPage from "../components/LazyLoadPage";
  import ErrorContentPage from "../components/ErrorContentPage";
  import EmptyContentPage from "../components/EmptyContentPage";

  import getDestakData from '../scripts/getDestakData'
  import SocialBar from "../components/SocialBar";

  export default {
    name: "Noticias",
    components: {SocialBar, ContainerBlackX, DestakCard, HeaderPrimary, LazyLoadPage, ErrorContentPage, EmptyContentPage},
    data() {
      return {
        news: [],
        newsDestak: [],
        state: {
          main: 0,
          load: 0,
          error: 1,
          empty: 2,
          content: 3,
        },
        sharedState: this.$store.state
      }
    },
    created() {
      this.findNews();
    },
    methods: {
      findNews() {
        let gdd = getDestakData();

        let { state } = this;

        this.state.main = state.load;

        gdd.then(data => {

          if(data.length === 0) {
            this.state.main = state.empty;
            return;
          }

          this.state.main = state.content;

          this.news = data;
          this.newsDestak = this.getDestakList()
        });

        gdd.catch(() => {
          this.state.main = state.error;
        })

      },
      getDestakList() {
        let nlist = this.news.splice(0, 3);

        if(nlist.length > 3){ return this.news; }



        let endList = [null, null, null];

        endList[0] = nlist[1];
        endList[1] = nlist[0];
        endList[2] = nlist[2];

        return endList;
      }
    }
  }
</script>
